import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import ResponsiveDropdown from './ResponsiveDropdown';

const Header = () => {
  return (
    <div className="header-container">
      <div className="header-left">
        <Link to="/" className="header-text">Northside Dental Partners</Link>
        <div className="custom-line"></div>
        <p className="address-subtext">
          <a 
            href="https://maps.app.goo.gl/MUTdzHJyVDB4DRcx5" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            ⟟ 8329 Roswell Road NE, Sandy Springs, GA 30350
          </a>
        </p>
        <p className="phone-subtext">Phone: <a href="tel:7706711111" style={{ color: 'inherit', textDecoration: 'none' }}>🕻 (770)-671-1111</a></p>
      </div>

      <div className="header-right">
        <Link to="/about">
          <button className="text-button">About</button>
        </Link>

        <ResponsiveDropdown />

        <Link to="/resources">
          <button className="text-button">Resources</button>
        </Link>
      </div>
    </div>
  );
};

export default Header;

